import { NgModule } from '@angular/core';
import { SvgIconsModule } from '@ngneat/svg-icon';
import { coreEditIcon } from './svg/edit';
import { coreInformationIcon } from './svg/information';
import { coreLinkIcon } from './svg/link';
import { navIcons } from './svg/nav';
import { coreNavLogoIcon } from './svg/navLogo';
import { coreNewIcon } from './svg/new';
import { coreToggleIcon } from './svg/toggle';

@NgModule({
	imports: [
		SvgIconsModule.forRoot({
			icons:[coreNewIcon, coreEditIcon, coreToggleIcon, coreInformationIcon, coreNavLogoIcon, coreLinkIcon, ...navIcons]
		})
	],
	exports: [SvgIconsModule]
})
export class IconModule {}
